module.exports = __webpack_public_path__ + "img/new_unactive_05.47718b7e.jpg";